import React from "react";

import dayjs from "dayjs";
import { Check } from "icons";

import { Steward } from "components/Common/TableStyle";

export const ASSOCIATE_DATA_SOURCE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "40%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "50%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const DATA_SOURCE_COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: 100,
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 250,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "type",
    key: "type",
    title: "Type",
    width: 100,
    render: () => <div className="whitespace-pre-line">RDBMS</div>,
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Data Source Status",
    width: 150,
    render: (text, record) => (
      <div className="whitespace-pre-line">
        {record?.unmapped_count === 0 ? "Ingested" : "Profiled"}
      </div>
    ),
  },
  {
    dataIndex: "dsdes_count",
    key: "dsdes_count",
    title: "# Data Source Data Element",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "unmapped_count",
    key: "unmapped_count",
    title: "# Incomplete DSDE",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 100,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 100,
  },
  {
    dataIndex: "updated_at",
    key: "updated_at",
    title: "Last Updated",
    width: 100,
    render: text => dayjs(text).format("MM/DD/YYYY"),
  },
];
